﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class JwtStorage {
    constructor(storage = null) {
        this.key = 'JWT_TOKEN';
        this.storage = window.localStorage;
        this.storage = storage ? storage : window.localStorage;
    }
    saveToken(token) {
        this.set(this.key, token);
    }
    readToken() {
        return this.get(this.key);
    }
    removeToken() {
        this.remove(this.key);
    }
    get(key) {
        return this.storage.getItem(key);
    }
    set(key, value) {
        this.storage.setItem(key, value);
    }
    remove(key) {
        this.storage.removeItem(key);
    }
}
exports.JwtStorage = JwtStorage;
//# sourceMappingURL=JwtStorage.js.map